import React from 'react';
import { Box, TextField, useTheme } from '@mui/material';
import { useAppTheme } from '@contexts/ThemeContext';

interface OTPInputProps {
    value: string[];
    onChange: (index: number, value: string) => void;
    onKeyDown: (index: number, e: React.KeyboardEvent<HTMLInputElement>) => void;
    onPaste: (e: React.ClipboardEvent) => void;
    disabled?: boolean;
}

const OTPInput: React.FC<OTPInputProps> = ({
    value,
    onChange,
    onKeyDown,
    onPaste,
    disabled = false,
}) => {
    const { isDarkMode } = useAppTheme();
    const theme = useTheme();
    return (
        <Box
            display="flex"
            gap={1.5}
            justifyContent="center"
            onPaste={onPaste}
        >
            {value.map((digit, index) => (
                <TextField
                    key={index}
                    id={`otp-${index}`}
                    value={digit}
                    onChange={(e) => onChange(index, e.target.value)}
                    onKeyDown={(e) => onKeyDown(index, e as React.KeyboardEvent<HTMLInputElement>)}
                    disabled={disabled}
                    inputProps={{
                        maxLength: 1,
                        style: {
                            textAlign: 'center',
                            fontSize: '1.2rem',
                            fontWeight: 'bold',
                        },
                    }}
                    sx={{
                        width: '48px',
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '12px',
                            backgroundColor: theme.palette.action.hover,
                            '& fieldset': {
                                borderColor: theme.palette.divider,
                            },
                            '&:hover fieldset': {
                                borderColor: theme.palette.text.primary,
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: theme.palette.primary.main,
                            },
                        },
                        '& .MuiInputBase-input': {
                            color: theme.palette.text.primary,
                            '&::placeholder': {
                                color: theme.palette.text.secondary,
                            },
                        },
                    }}
                />
            ))}
        </Box>
    );
};

export { OTPInput };
